// Základní response processor
class ResponseProcessor
{
    async processAsync(data)
    {
        throw new Error('Process method must be implemented');
    }
}

class AddToCartResponseProcessor extends ResponseProcessor
{
    async processAsync(data)
    {
        if (data.success || data.isValid) // isValid = quickOrder
            return true;

        var title = await window.localization.get("errors.chyba");

        Swal.fire(
        {
            title: title,
            text: data.message,
            icon: "error"
        });

        return false;
    }
}

class QuickOrderResponseProcessor extends ResponseProcessor
{
    async processAsync(data)
    {
        if (data.success)
            return true;

        var title = await window.localization.get("errors.chyba");

        Swal.fire(
        {
            title: title,
            text: data.message,
            icon: "error"
        });

        return false;
    }
}

class ResponseProcessorFactory
{
    constructor()
    {
        this.processors = new Map();
        this.urlPatterns = new Map();

        // Register default processors
        this.registerProcessor("addToCart", AddToCartResponseProcessor);
        this.registerProcessor("quickOrder", AddToCartResponseProcessor);

        // Register default URL patterns
        this.urlPatterns.set("/api/cart/add", "addToCart");
        this.urlPatterns.set("/api/cart/remove", "addToCart");
        this.urlPatterns.set("/api/cart/update", "addToCart");
        this.urlPatterns.set("/api/cart/quick-order", "quickOrder");
    }

    // Register new processor types
    registerProcessor(type, processorClass)
    {
        this.processors.set(type, processorClass);
    }

    // Get processor based on URL
    getProcessorFromUrl(url)
    {
        var key;

        for (var k of this.urlPatterns.keys())
        {
            if (url.includes(k))
            {
                key = k;

                break;
            }
        }

        if (key)
        {
            const type = this.urlPatterns.get(key);

            return this.createProcessor(type);
        }

        console.log(`No processor found for URL: ${url}`);

        return null;
    }

    // Get processor based on form reference
    getProcessorFromReference(reference)
    {
        if (this.processors.has(reference))
            return this.createProcessor(reference);
        
        console.log(`No processor found for reference: ${reference}`);

        return null;
    }

    // Create processor instance
    createProcessor(type)
    {
        const ProcessorClass = this.processors.get(type);

        if (ProcessorClass)
            return new ProcessorClass();
        
        throw new Error(`Processor type not registered: ${type}`);
    }
}

window.responseFactory = new ResponseProcessorFactory();